import { Grid, TextField } from '@mui/material';
import styled from 'styled-components';

import CommonComponentStyle from 'commons/styles/basic-components.styles';

class InboundListPageStyle extends CommonComponentStyle {
  SearchBar = styled(TextField)`
    width: 100%;
    margin: 12px 0 8px 0 !important;
  `;

  SKUGridWrapper = styled(Grid)`
    background: ${this.colors.LIGHTER_GRAY};
    padding: 8px 0;
  `;

  SKUGrid = styled(Grid)`
    font-size: 14px;
    padding-top: 8px;

    &.bold {
      font-weight: 700;
    }
  `;

  ButtonGrid = styled(Grid)`
    text-align: right;
  `;

  ProgressSpan = styled.span`
    color: ${this.colors.PRIMARY_GRAY};
    margin-left: 8px;
  `;

  TableInfoGrid = styled(Grid)`
    padding: 8px 0 0 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.25);

    &.no-pad-top {
      padding-top: 0;
      padding-bottom: 16px;
    }
  `;

  FOCText = styled.span`
    border-radius: 8px;
    font-size: 10px;
    background: ${this.colors.LIGHTER_ORANGE};
    color: ${this.colors.PRIMARY_ORANGE};
    padding: 6px;
  `;
}

export default new InboundListPageStyle();
